<template>
  <div>
    <h3 class="d-flex justify-start py-5">{{ $t('export.history') }}</h3>
    <v-data-table
      :loading="loading"
      :items="exportsList"
      :headers="headers"
      :no-data-text="$t('table_settings.no_data')"
      :loading-text="$t('table_settings.loading_data')"
      :header-props="{
        sortByText: $t('table_settings.sort_by')
      }"
      :footer-props="{
        itemsPerPageAllText: $t('table_settings.all'),
        itemsPerPageOptions: [10, 25, 50, -1],
        itemsPerPageText: $t('table_settings.items_per_page')
        }">
      <template v-slot:[`item.createdDate`]="{ item }">
        {{ convertToLocalDateTime(item.createdDate) }}
      </template>
      <template v-slot:[`item.download`]="{ item }">
        <v-icon
          small
          class="mr-1"
          @click="downloadExport(item.id)">
          mdi-download-outline
        </v-icon>
      </template>
    </v-data-table>
    <v-snackbar v-model="showLoadingErrorSnackbar" color="error">
      {{ $t('common_error.could_not_load_items')}}
    </v-snackbar>
    <v-snackbar v-model="showDownloadErrorSnackbar" color="error">
      {{ $t('export.download_error') }}
    </v-snackbar>
    <v-dialog
      v-model="showDownloadProgress"
      persistent
      width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t('export_download.downloading') }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0">
          </v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import ExportService from '@/services/export/ExportService'
import api from '@/services/api/api'

export default {
  name: 'ExportHistory',
  data: () => ({
    loading: false,
    showLoadingErrorSnackbar: false,
    showDownloadErrorSnackbar: false,
    showDownloadProgress: false,
    headers: [
      {
        text: i18n.t('export.name'),
        value: 'name',
        align: 'start',
        sortable: true
      },
      {
        text: i18n.t('export.created_date'),
        value: 'createdDate',
        align: 'start',
        sortable: true
      },
      {
        text: i18n.t('table_settings.download'),
        align: 'end',
        value: 'download',
        sortable: false
      }
    ]
  }),
  computed: {
    exportsList () {
      return this.$store.state.exports.exportsList
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('exports/refreshExports').then(result => {
      this.loading = false
    }, _ => {
      this.loading = false
      this.showLoadingErrorSnackbar = true
    })
    if (this.$route.params.downloadExportId != null) {
      this.downloadExport(this.$route.params.downloadExportId)
    }
  },
  methods: {
    downloadExport (exportId) {
      this.showDownloadProgress = true
      ExportService.openExportDownload(exportId).then(response => {
        window.open(api.defaults.baseURL + '/download/' + response)
      }, _ => {
        this.showDownloadErrorSnackbar = true
      })
      this.showDownloadProgress = false
    },
    convertToLocalDateTime (dateTimeOffset) {
      var localDate = new Date(dateTimeOffset)
      return localDate.getDate() + '.' + localDate.getMonth() + '.' +
        localDate.getFullYear() + ' ' + localDate.getHours() + ':' + localDate.getMinutes().toString().padStart(2, '0')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/exports/ExportHistory.vue